import { Navigate, useLocation } from 'react-router-dom';
import { useFirmManagedCase } from '@/hooks/useFirmManagedCase';
import { isFirmBlockedRoute } from '@/lib/firmClientExperience';

/**
 * Route-level guard for the psych/negotiation suite (#1518).
 *
 * Firm-managed clients are redirected to /dashboard — nav hiding alone is not
 * enough, direct URLs must be blocked too (ROF F-C4). DIY clients pass
 * through untouched. Renders nothing while the firm-managed query resolves so
 * a blocked page never flashes.
 */
export function FirmManagedRouteGuard({ children }: { children: React.ReactNode }) {
  const { isFirmManaged, isLoading } = useFirmManagedCase();
  const { pathname } = useLocation();

  if (isLoading) return null;
  if (isFirmBlockedRoute(pathname, isFirmManaged)) {
    return <Navigate to="/dashboard" replace />;
  }
  return <>{children}</>;
}
